import React, { useState, useEffect } from 'react';
import cN from 'classnames';
import { getFilterCount } from '../utils';

import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { setSortType } from '@Redux/search/actions';

import { Select } from '@lion-design/core';
import { FilterIcon } from '@features/ui/Icons';
import { SearchResultSort } from '@features/sorters';
import { FilterConditions } from '@features/searchFilters';

interface I_SearchToolbarProps {
    handleToolbarClick: () => void;
}

const SearchToolbar = ({ handleToolbarClick }: I_SearchToolbarProps) => {
    const dispatch = useDispatch();
    const { FilterData, SortType } = useSelector((state: RootState) => state.search);

    const [isFixed, setIsFixed] = useState(false);

    // TODO: 待確認同步外部系統做法
    useEffect(() => {
        const handleScroll = () => setIsFixed(window.pageYOffset >= 176);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const filterCount = getFilterCount(FilterData);
    const selectTabs = [
        { text: '低價優先', value: '1' },
        { text: '省時優先', value: '2' },
    ];

    const handleSelect = (type: string | number) => {
        switch (type) {
            case '1':
                dispatch(setSortType('price'));
                break;
            case '2':
                dispatch(setSortType('time'));
                break;
        }
    };

    return (
        <>
            <div id='fixedTopElement' className={cN('toolbarM', { fixed: isFixed })}>
                <div className="filterM" onClick={handleToolbarClick}>
                    {`篩選(${filterCount})`}
                    <FilterIcon />
                </div>
                <div className="selectBar">
                    <Select
                        data={selectTabs}
                        onChange={(e) => handleSelect(e)}
                        defValue={SortType === 'price' ? '1' : '2'}
                    />
                </div>
            </div>

            <div className="toolbarPc">
                <FilterConditions />
                <SearchResultSort />
            </div>
        </>
    );
};

export default SearchToolbar;
